import { useMutation } from "@tanstack/react-query";

export const useTransactionWithBody = (
  onError?: (response: Response) => void,
) => {
  const mutation = useMutation<
    {
      requestId: number;
    },
    Error,
    Record<string, unknown>
  >({
    mutationKey: [onError],
    mutationFn: async (body) => {
      const response = await fetch(
        `${window.__APP_CONFIG.apiBaseUrl}/head/requests`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        },
      );

      if (!response.ok) {
        if (onError) {
          onError(response);
        } else {
          throw new Error(
            `Hydrozoa operation failed with status ${response.status}`,
          );
        }
      }

      return response.json();
    },
  });

  return mutation;
};
